import React from 'react';
import './PayoutSetupScreen.css';

const PayoutSetupScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="payout-setup-screen">
      <h1>Payout Setup</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default PayoutSetupScreen; 